(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("collapseitem", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["collapseitem"] = factory(require("vue"));
	else
		root["collapseitem"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8__) {
return 